import React, {useState} from 'react';
import './ExpenseForm.css';
const ExpenseForm=(props)=>{

const [enteredTitle,setEnteredTitle]=useState('');
const [enteredAmount,setEnteredAmount]=useState('');
const [enteredDate,setEnteredDate]=useState('');


   const titleChangeHandler=(event)=>{
    setEnteredTitle(event.target.value);
 
   }

   const amountChangeHandler=(event)=>{
    setEnteredAmount(event.target.value);

   }

   const dateChangeHandler=(event)=>{
    setEnteredDate(event.target.value);

   }

  const submitHandler=(event)=>{
    event.preventDefault();

    const expenseData= {             //object to store all the data input by user
        title:enteredTitle, 
        amount :enteredAmount,
        date:new Date(enteredDate),
    };
      props.onSaveExpenseData(expenseData);    //onSaveExpenseData vala function jo iske parent me bana hua h usko call
                                               // kari hai props keyword lagake aur saath me ye updated vala object bhi pass kar dia hai..

     setEnteredTitle('');  //to reset or clear the values from the form after saving it
     setEnteredAmount(''); //to reset or clear the values from the form after saving it
     setEnteredDate('');  //to reset or clear the values from the form after saving it

  };



    return <form onSubmit={submitHandler}>
                <div className='new-expense__controls'>
                    
                    <div className='new-expense__controls'>  
                        <label>Title </label>
                        <input type="text" value={enteredTitle} onChange={titleChangeHandler}></input>
                     </div>

                     <div className='new-expense__controls'>  
                        <label>Amount </label>
                        <input type="number" value={enteredAmount} min="0.01" step="0.01" onChange={amountChangeHandler} ></input>
                     </div>

                     <div className='new-expense__controls'>  
                        <label>Date </label>
                        <input type="date" value={enteredDate} min="2019-01-01" max="2022-12-31" onChange={dateChangeHandler}></input>
                     </div>

                </div>

                <div className="new-expense__actions">
                  
                   <button type="button" onClick={props.onCancel}>Cancel</button> 
                   <button type="submit">Add Expense</button>

             
                </div>

           </form>




}
export default ExpenseForm; 